import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { change, FieldArray, reduxForm } from 'redux-form';

import { Typography } from '@material-ui/core';
import AddOnsList from 'pages/book-activity/components/add-ons-list/AddOnsList';

import BookingInformation from '../booking-information/BookingInformation';

import useStyles from './styles';

const initialValues = {
  addOns: []
};

const AddOns = ({
  accommodationData,
  widgetForm,
  changeFormFieldValue,
  handleSubmit
}) => {
  const classes = useStyles();
  const [t] = useTranslation();

  const currency = widgetForm.values.currency;

  React.useEffect(() => {
    setAddOns(accommodationData);
  }, [accommodationData]);

  const setAddOns = accommodation => {
    const receivedAddOns = accommodation.addOnsForm.addOns;
    const createdAddOns = widgetForm.values.addOns;

    if (createdAddOns && createdAddOns.length) return;

    const addOnsList = receivedAddOns.map(item => {
      return {
        ...item,
        value: 0
      };
    });

    changeFormFieldValue('addOns', addOnsList);
  };

  return (
    <div className={classes.wrapper}>
      <div className={classes.leftSide}>
        <form onSubmit={handleSubmit} className={classes.form}>
          <Typography
            variant="h3"
            classes={{ root: classes.sectionTitleIndent }}
          >
            {t('Select additional options')}
          </Typography>

          <FieldArray
            name="addOns"
            currency={currency}
            titleClass={classes.addOnTitleClass}
            wrapperClass={classes.addOnWrapperClass}
            addOnItemClass={classes.addOnItemClass}
            addOnDescClass={classes.addOnDescClass}
            isWidget={true}
            component={AddOnsList}
          />

          <button hidden={true} type={'submit'}>
            Submit
          </button>
        </form>
      </div>
      <div className={classes.rightSide}>
        <BookingInformation data={accommodationData} form={widgetForm} />
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    widgetForm: state.form.widgetForm
  };
};

const mapDispatchToProps = dispatch => ({
  changeFormFieldValue: (field, value) => {
    dispatch(change('widgetForm', field, value));
  }
});

export default reduxForm({
  form: 'widgetForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  touchOnBlur: false,
  initialValues
})(connect(mapStateToProps, mapDispatchToProps)(AddOns));
